/* eslint-disable */
import { Middleware } from "@sa/rep-common";
import { DataFlowProcessingState } from "@sa/rep-core";
import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { ServiceProvider } from "@sa/rep-services-provider";
import { ServicesRegister } from "../../../shared";
import { REPORT_ID, REPORT_APE_ID, SLIDE_NUMBER } from '../constants';

export const report11DataflowMiddlewares = (serviceProvider: ServiceProvider) => {
  const lastYearsBusinessUnits = new Map<number, number>();
  const reportParameters = new Map<string, unknown>();
  const dictionariesServices = serviceProvider.resolve<DictionariesService>(ServicesRegister.Dictionary);

  return async (input, next) => {
    if ([REPORT_APE_ID, REPORT_ID].includes(input.reportId)) {
      const parameters = input.parameters as Map<string, unknown>;
      if (parameters.has("@business-units")) {
        const businessUnit = parameters.get("@business-units") as number;
        let lastYear: number;
        const dictCommodities = await dictionariesServices.getDictionary({
          id: 'slides-commodities-display',
          parameters: {
            'slide': SLIDE_NUMBER,
            'business_unit': businessUnit,
          }
        });
        const itemsCommodities = await dictCommodities.getAll();
        const commodities = itemsCommodities.map(x => x.getValue<number>('olap_commodity'));

        // const dictSlideCountries$ = commodities.map(commodity => (async () => {
        //   const dict = await dictionariesServices.getDictionary({
        //     id: 'slides-countries-display',
        //     parameters: {
        //       'slide': SLIDE_NUMBER,
        //       'olap_commodity': commodity,
        //       'business_unit': businessUnit
        //     }
        //   });
        //   const items = await dict.getAll();
        //   return [Number(commodity), items] as [number, DictionaryItem[]];
        // })());
        // const dictSlideCountries = (await Promise.all(dictSlideCountries$));
        // const itemsCountries = dictSlideCountries.flatMap(([, items]) => items);

        const attributes = [1];
        const countries = []//itemsCountries.map(item => item.id);
        const units = [9];

        const dictionary = await dictionariesServices.getDictionary({
          id: 'slides-f-last-calendar',
          parameters: {
            attributes: attributes.join(','),
            countries: countries.join(','),
            commodities: commodities.join(','),
            units: units.join(','),
            slide: SLIDE_NUMBER,
          }
        });
        const items = await dictionary.getAll();
        const year = new Date().getFullYear();
        lastYear = Number(`1${year}0101`);
        const candidate = items.length ? Number(items[0].id) : null;
        if (candidate) {
          lastYear = candidate;
          lastYearsBusinessUnits.set(businessUnit, lastYear);
        }

        parameters.set("@last_year", lastYear);
        parameters.set("@calendar", [lastYear]);
      }

      for (const key of parameters.keys()) {
        reportParameters.set(key, parameters.get(key))
      }
    }
    return next(input);
  }
}
